import React, { ChangeEvent, KeyboardEvent } from "react";
import { RowItem } from "../models/Core/row-item";
import * as app from "../services/AppService";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";

interface InputProps extends RowItem, InterfaceComponentsProps {
    onChange?: (value: string, key: string | undefined) => void;
    model: string | number;
    onBlur?: () => void;
    elmKey?: string | number;
    required?: boolean;
    onEnterClicked?: () => void;
    iconClicked?: () => void;
    maxlength?: number;
    containerClass?: string;
    symbol?: string;
    placeholder?: string;
    withLabel?: boolean;
    iconClass?: string;
    tableClass?: string;
    autoComplete?: "on" | "off";
}

function Input(props: InputProps) {
    function handler(event: ChangeEvent<HTMLInputElement>) {
        const { value } = event.target;
        if (props.onChange && typeof props.onChange == "function")
            props.onChange(value, props.elmKey?.toString());
    }

    function hanldeKeydown(evt: KeyboardEvent<HTMLInputElement>): void {
        if (
            evt.key === "Enter" &&
            props.onEnterClicked &&
            typeof props.onEnterClicked == "function"
        )
            props.onEnterClicked();
    }

    function iconClicked() {
        if (props.iconClicked && typeof props.iconClicked == "function")
            props.iconClicked();
    }

    function inputBlur() {
        if (props.onBlur && typeof props.onBlur == "function") props.onBlur();
    }

    let input = (
        <input
            type="text"
            maxLength={props.maxlength}
            id={props.id ? props.id : "inpt" + props.label}
            key={props.elmKey}
            className={`form-control form-control-sm  ${props.required && !props.model
                    ? " is-invalid  border-1"
                    : props.isTable
                        ? " border-1 text-center  " + props.tableClass
                    : "border-0 rounded" + props.class
                }`}
            disabled={props.disabled}
            onChange={handler}
            value={props.model}
            onBlur={inputBlur}
            onKeyDown={hanldeKeydown}
            placeholder={app.translate(props.placeholder) + props.symbol}
            required={props.required && !props.model}
            autoComplete={props.autoComplete || null!}
        />
    );

    return props.isTable ? (
        input
    ) : (
        <div className="mt-1">
            {props.withLabel && (
                <label className={`${props.labelClass}`}>
                    {app.translate(props.label)}
                </label>
            )}
            <div className={`input-group border rounded  ${props.containerClass}`}>
                {input}
                {props.icon && (
                    <button
                        className={`btn btn-sm border-0 p-0 px-2 ${props.iconClass}`}
                        type="button"
                        disabled={!props.iconClicked}
                        onClick={iconClicked}
                    >
                        <i className={` iconssc-${props.icon}`} />
                    </button>
                )}
            </div>
        </div>
    );
}

Input.defaultProps = {
    labelClass: "fw-semibold text-primary-emphasis",
    type: "text",
    disabled: false,
    required: false,
    elmKey: "input",
    isTable: false,
    withLabel: true,
    symbol: "",
    onEnterClicked: undefined,
    iconClicked: undefined,
    maxlength: undefined,
    containerClass: "",
    placeholder: "",
    icon: "",
    iconClass: "",
    tableClass: "",
    class: "",
}

export default Input;
